module.exports = __webpack_public_path__ + "img/home-popup-title4.87ebaaae.png";